export default __webpack_public_path__ + "static/media/hp-review-quotation-icon.00edf98c.svg";